import React  from 'react';
import { useSelector } from 'react-redux';

import SalesUsersModal from './modals/SalesUsersModal';
import NewSalesUserModal from './modals/NewSalesUserModal';
import NewPhotoMeetingModal from './modals/NewPhotoMeetingModal';

const ModalsContainer = () => {
  const { salesUser, displaySalesUsersModal } = useSelector((state) => state.sellerSalesUsers);
  const { newPhotoMeetingModalOpen } = useSelector((state) => state.sellerPhotoMeetings);
  
  return (
    <div data-testid='ModalsContainer'>
      {displaySalesUsersModal && <SalesUsersModal />}
      {salesUser && <NewSalesUserModal />}
      {newPhotoMeetingModalOpen && <NewPhotoMeetingModal />}
    </div>
  );
}

export default ModalsContainer;
